module.exports = __webpack_public_path__ + "static/media/1.5ecc3721.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/mozyr/1.jpg
// module id = 238
// module chunks = 0